// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".message-card[data-v-e6e761f2]{max-height:100dvh;max-width:100vw;min-width:300px;overflow-y:auto}@supports not (max-height:100dvh){.message-card[data-v-e6e761f2]{max-height:100vh}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
